import axios from 'axios';

export default class BaseService {
  public responseData;
  public hasBeenRequested: boolean = false;

  constructor(
    protected endpoint: string = '',
    private shouldCacheRequest: boolean = true,
  ) {}

  public get() {
    const config = {
      withCredentials: true,
    };
    if (this.shouldRequestResponse()) {
      this.hasBeenRequested = true;
      this.responseData = axios
        .get(this.endpoint, config)
        .then((response) => this.handleResponse(response))
        .catch((e) => {
          // console.log('Request Failed', e)
        });
    }
    return this.responseData;
  }

  public post(smsession) {
    const config = {
      withCredentials: true,
    };
    if (this.shouldRequestResponse()) {
      this.hasBeenRequested = true;
      this.responseData = axios
        .post(this.endpoint, { smsession }, config)
        .then((response) => this.handleResponse(response))
        .catch((e) => {
          // console.log('Request Failed', e)
        });
    }
    return this.responseData;
  }

  public shouldRequestResponse() {
    return !this.shouldCacheRequest || !this.hasBeenRequested;
  }

  public handleResponse(response) {
    return response.data;
  }

  public clearCache(): void {
    this.hasBeenRequested = false;
  }

  public setEndpoint(endpoint: string): void {
    this.endpoint = endpoint;
  }
}
